import React from 'react';
// import { Link } from 'react-router-dom';

// The Header creates links that can be used to navigate
// between routes.
const Footer = () => (
  <footer>
    <div className='container'>
      <div className='row'>
        <div className='col-12 col-lg-6'>
          <img src='/img-tipos/logos/logoogr.png' style={{ width: '270px' }} />
        </div>
        <div className='col-12 col-lg-6'>
          Al ingresar sus datos, enviará su información a la Universidad Mayor,
          para ser utilizada en la entrega de información sobre sus servicios.
          La información recopilada sólo es utilizada por la Universidad Mayor y
          no es transferida a otras empresas.
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js